<script setup>
defineProps({
  menuItemUrl: {
    type: String,
    required: true,
  },
  menuItemLabel: {
    type: String,
    required: true,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <li :class="{ 'is-active': isActive }">
    <a :href="menuItemUrl">
      {{ menuItemLabel }}
    </a>
  </li>
</template>
